import { CaptchaComponent } from "@soqs/common";
import React from "react";
import {
  captchaImage,
  submitCaptchaAsync,
  refreshCaptchaAsync,
  captchaAudio,
  isLoading,
} from "../features/AppSlice";
export default function Captcha() {
  return (
    <CaptchaComponent
      captchaImage={captchaImage}
      submitCaptcha={submitCaptchaAsync}
      refreshCaptcha={refreshCaptchaAsync}
      captchaAudio={captchaAudio}
      isLoading={isLoading}
    ></CaptchaComponent>
  );
}
